/**
 * Created  on 2019/07.
 */
/**
 * 设置屏幕
 * */
/* eslint-disable */
new function () {
  let _self = document.body
  _self.width = 640
  _self.fontSize = 100
  _self.widthProportion = function () {
    let p = 0
    if (document.body) {
      p = document.body.clientWidth / _self.width
    } else {
      p = document.getElementsByTagName('html')[0].offsetWidth / _self.width
    }
    return p < 0.5 ? 0.5 : p
  }
  _self.changePage = function () {
    document.getElementsByTagName('html')[0].setAttribute('style', 'font-size:' + _self.widthProportion() * _self.fontSize + 'px')
  }
  _self.changePage()
  window.addEventListener('resize', function () {
    _self.changePage()
  }, false)
}



// WEBPACK FOOTER //
// ./src/utils/reset.js